import { ButtonShape } from 'types';

export const getCustomButtonStyle = (value: string, color: string) =>
  value === ButtonShape.SQUARE ? { border: `1px solid ${color}`, borderRadius: '0' } : {};
